import type { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Typography } from "@mui/material";

import { PATHS } from "../../constants";

import notFoundImage from "./assets/not-found.png";

interface NotFoundPageProps {
  title?: string;
  message?: string;
  backButtonLabel?: string;
  backTo?: string;
}

const DEFAULT_NOT_FOUND_TITLE = "Не удалось открыть страницу";
const DEFAULT_NOT_FOUND_MESSAGE = "Возможно она удалена или ссылка некорректна";

export const NotFoundPage: FC<NotFoundPageProps> = ({
  title = DEFAULT_NOT_FOUND_TITLE,
  message = DEFAULT_NOT_FOUND_MESSAGE,
  backButtonLabel = "Вернуться",
  backTo,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    if (backTo) {
      navigate(backTo);
    } else if (location.key === "default") {
      navigate(PATHS.MAIN_PAGE, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        pt: "50px",
        px: 2,
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src={notFoundImage}
        alt={title}
        sx={{
          height: "auto",
          maxWidth: "100%",
          width: 384,
        }}
      />
      <Typography
        variant="h4"
        component="h1"
        sx={{
          color: ({ palette }) => palette.text.primary,
          fontWeight: 400,
          letterSpacing: 0,
          lineHeight: "100%",
          mt: "20px",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        component="p"
        sx={{
          color: ({ palette }) => palette.text.primary,
          fontWeight: 400,
          letterSpacing: 0,
          lineHeight: "100%",
          mt: "18px",
        }}
      >
        {message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={handleBackClick}
        sx={{ mt: "29px", color: ({ palette }) => palette.primary.contrast }}
      >
        {backButtonLabel}
      </Button>
    </Box>
  );
};
